<template>
  <div class="long-text-con">
    <vp-textarea
      :label="field.is_mandatory && !field.is_optional ? field.name : field.name + ` ${$t('common.optionalWithBrackets')}`"
      v-model="textareaModel.value"
      rows="3"
      maxlength="255"
      width="415"
      @input="emitUpdate"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  props: {
    field: {},
  },
  data() {
    return {
      textareaModel: null,
    };
  },
  beforeMount() {
    this.textareaModel = cloneDeep(this.field);
  },
  methods: {
    emitUpdate() {
      this.$emit("updateLongText", this.textareaModel);
    },
  },
};
</script>
<style lang="scss">
.long-text-con {
  .md-field.md-theme-default.md-has-textarea {
    height: 124px !important;
    width: 416px !important;
  }
  textarea {
    padding-top: 5px !important;
  }
}
</style>